export default "__VITE_ASSET__CdHBUpjv__"